import { PasscodePromptError } from 'utils/passcodeUtils';
import BaseComponent from '@tock/shared/components/BaseComponent';
import CallOut from '@tock/shared/components/CallOut';
import ComposableModal from 'components/composable-modal/ComposableModal';
import ComposableModalBody from 'components/composable-modal/ComposableModalBody';
import ComposableModalHeader from 'components/composable-modal/ComposableModalHeader';
import ComposableModalHeading from 'components/composable-modal/ComposableModalHeading';
import PasscodeInput, { PASSCODE_LENGTH } from 'components/passcode/PasscodeInput';

interface Props {
  onClose(): void;
  onPasscodeEntered(passcode: string): void;
  errorMessage: string;
  errorCode: PasscodePromptError;
}

interface State {
  passcode: string;
}

export default class PasscodePromptModal extends BaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      passcode: '',
    };
  }

  changePasscode(passcode: string) {
    this.setState({ passcode }, () => {
      if (this.state.passcode.length === PASSCODE_LENGTH) {
        this.props.onPasscodeEntered(this.state.passcode);
      }
    });
  }

  renderError() {
    switch (this.props.errorCode) {
      case PasscodePromptError.INCORRECT_PASSCODE:
        return 'Incorrect code. Please try again.';
      default:
        return this.props.errorMessage;
    }
  }

  render() {
    return (
      <ComposableModal onClose={this.props.onClose}>
        <ComposableModalHeader>
          <ComposableModalHeading heading="Passcode required" onClose={this.props.onClose} />
        </ComposableModalHeader>
        <ComposableModalBody modifierClassName="ComposableModalBody--collapsed">
          <div className="PasscodePromptModal">
            <div className="PasscodePromptModal-message">
              {this.props.errorCode === PasscodePromptError.PASSCODE_REQUIRED ? (
                this.props.errorMessage
              ) : (
                <CallOut>{this.renderError()}</CallOut>
              )}
            </div>

            <PasscodeInput passcode={this.state.passcode} onPasscodeChanged={this.changePasscode} />
          </div>
        </ComposableModalBody>
      </ComposableModal>
    );
  }
}
